module.exports = __webpack_public_path__ + "img/female-avatar2.ec5a8de8.png";